import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ChatLogsAPI from '../api/ChatLogsAPI';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loadingAuth, setLoadingAuth] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const access = sessionStorage.getItem('accessKey')
        const kSP = urlParams.get('k');
        
        const validate = async () => {
            setLoadingAuth(true)
            let result = await ChatLogsAPI.checkKey({ key: kSP })
            if (!result) {
                setIsAuthenticated(false)
            }
            else {
                sessionStorage.setItem('accessKey', result.agent);
                setIsAuthenticated(true)
            }
            setLoadingAuth(false)
        }

        if (!kSP && !access) {
            setLoadingAuth(false)
            setIsAuthenticated(false)
            return
        }
        if (access) {
            setIsAuthenticated(true)
            setLoadingAuth(false)
        } else validate()

    }, [location.search]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, loadingAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
